export default {
    active: true,
    seed: 92,
    skyType: "gradient",
    skyColor: "#4a070f",
    horizonColor: "#f62300",
    lighting: "point",
    lightPosition: { x: 0.5, y: 2.25, z: 0 },
    fog: 0.87,
    flatShading: false,
    playArea: 1,
    ground: "canyon",
    groundYScale: 9.76,
    groundTexture: "walkernoise",
    groundColor: "#fb0803",
    groundColor2: "#510000",
    dressing: "arches",
    dressingAmount: 15,
    dressingColor: "#fb0803",
    dressingScale: 3,
    dressingVariance: { x: 10, y: 100, z: 10 },
    dressingUniformScale: false,
    dressingOnPlayArea: 0.2,
    grid: "none",
    gridColor: "#fa0e00",
    shadow: false,
};
